<h2 mat-dialog-title>Step 4: Map Assets</h2>
<mat-dialog-content>
  <div class="master-suite-columns" data-testid="master-suite-subheading">
    <div class="master-suite-column source-column">
      <div class="master-suite-label">Source Master Suite: {{ sourceMasterSuiteName }}</div>
      <div class="enhancement-variant-label enhancement-variant-label-source" data-testid="source-enhancement-variant-label">
        <mat-icon>auto_awesome</mat-icon>
        Enhancement Variant: {{ sourceEnhancementVariantName }}
      </div>
      @if (dropMappings.length > 0) {
        <div class="dropped-touches" data-testid="dropped-touches-section">
          <h4>Touches to be deleted</h4>
          @for (touchMapping of dropMappings; track touchMapping.sourceTouchId) {
            @let droppedSource = sourceTouchFor(touchMapping.sourceTouchId);
            @if (droppedSource) {
              <div class="dropped-touch" data-testid="dropped-touch-block">
                <div class="dropped-touch-label">{{ touchLabel(droppedSource) }}</div>
                <div class="dropped-touch-counts" data-testid="dropped-touch-counts">
                  {{ shootAssetCount(touchMapping.sourceTouchId) }} shoot assets · {{ postAssetCount(touchMapping.sourceTouchId) }} post assets
                </div>
                <ul class="dropped-asset-list">
                  @for (asset of droppedTouchAssets(touchMapping.sourceTouchId); track asset.id) {
                    <li data-testid="dropped-asset-item">{{ assetLabel(asset) }}</li>
                  }
                </ul>
              </div>
            }
          }
        </div>
      }
    </div>
    <div class="master-suite-column destination-column">
      <div class="master-suite-label">Destination Master Suite: {{ destinationMasterSuiteName }}</div>
      <div class="enhancement-variant-label enhancement-variant-label-destination" data-testid="enhancement-variant-label">
        <mat-icon>auto_awesome</mat-icon>
        Enhancement Variant: {{ destinationEnhancementVariantName }}
      </div>
      @if (newDestinationTouches.length > 0) {
        <div class="new-touches" data-testid="new-touches-section">
          <h4>Touches to be created</h4>
          <ul>
            @for (touch of newDestinationTouches; track touch.id) {
              <li data-testid="new-touch-item">{{ touchLabel(touch) }}</li>
            }
          </ul>
        </div>
      }
    </div>
  </div>
  @if (mapMappings.length === 0 && dropMappings.length === 0) {
    <p data-testid="no-mappings-message">No touches to map — you can confirm to proceed.</p>
  }
  @if (mapMappings.length > 0) {
    <div class="drag-hint" data-testid="drag-hint">
      <mat-icon>drag_indicator</mat-icon>
      Drag assets between Discard and Destination slots to change how they map.
    </div>
  }
  <mat-accordion multi data-testid="asset-mapping-accordion">
    @for (touchMapping of mapMappings; track touchMapping.sourceTouchId) {
      @let sourceTouch = sourceTouchFor(touchMapping.sourceTouchId);
      @let destinationTouch = destinationTouchFor(touchMapping.destinationTouchId);
      @if (sourceTouch && destinationTouch) {
        <mat-expansion-panel expanded data-testid="asset-mapping-panel">
          <mat-expansion-panel-header>
            <mat-panel-title>{{ touchLabel(sourceTouch) }} → {{ touchLabel(destinationTouch) }}</mat-panel-title>
            <mat-panel-description data-testid="asset-mapping-panel-counts">
              {{ affectedProductCount(touchMapping.sourceTouchId) }} products · {{ shootAssetCount(touchMapping.sourceTouchId) }} shoot assets · {{ postAssetCount(touchMapping.sourceTouchId) }} post assets
            </mat-panel-description>
          </mat-expansion-panel-header>
          <app-asset-mapping-sub
            [sourceTouch]="sourceTouch"
            [destinationTouch]="destinationTouch"
            [sourceEnhancementFlaggedAssetIds]="data.prepareResult.sourceEnhancementFlaggedAssetIds ?? []"
            [destinationEnhancementFlaggedAssetIds]="data.prepareResult.destinationEnhancementFlaggedAssetIds ?? []"
            (assetMapChanged)="onAssetMapChanged(touchMapping.sourceTouchId, $event)"
          ></app-asset-mapping-sub>
        </mat-expansion-panel>
      }
    }
  </mat-accordion>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()" type="button">Cancel</button>
  <button mat-raised-button color="primary" (click)="confirm()" type="button" [disabled]="submitting">
    Confirm
  </button>
</mat-dialog-actions>
